import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';

export interface EmployeeActiveDaysParams {
  id?: number;
  user_id?: number;
  sector_id?: number;
  district_id?: number;
  week_day?: number;
  is_active?: boolean;
  user_id_list?: number[];
  sector_id_list?: number[];
  district_id_list?: number[];
  limit?: number;
  offset?: number;
}

export interface EmployeeActiveDayUser {
  user_id: number;
  last_name: string;
  first_name: string;
  patronymic_name: string;
}

export interface EmployeeActiveDayDistrict {
  d_id: number;
  district_name: string;
}

export interface EmployeeActiveDay {
  id: number;
  sector_id: number;
  district: EmployeeActiveDayDistrict;
  user: EmployeeActiveDayUser;
  week_day: number;
  is_active: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ResourceDistributionService {
  constructor(private http: HttpClient) {}

  getEmployeeActiveDays(params?: EmployeeActiveDaysParams): Observable<any> {
    let httpParams = new HttpParams();

    if (params) {
      if (params.id !== undefined) {
        httpParams = httpParams.set('id', params.id.toString());
      }
      if (params.user_id !== undefined) {
        httpParams = httpParams.set('user_id', params.user_id.toString());
      }
      if (params.sector_id !== undefined) {
        httpParams = httpParams.set('sector_id', params.sector_id.toString());
      }
      if (params.district_id !== undefined) {
        httpParams = httpParams.set('district_id', params.district_id.toString());
      }
      if (params.week_day !== undefined) {
        httpParams = httpParams.set('week_day', params.week_day.toString());
      }
      if (params.is_active !== undefined) {
        httpParams = httpParams.set('is_active', params.is_active.toString());
      }
      if (params.user_id_list && params.user_id_list.length > 0) {
        httpParams = httpParams.set('user_id_list', params.user_id_list.join(','));
      }
      if (params.sector_id_list && params.sector_id_list.length > 0) {
        httpParams = httpParams.set('sector_id_list', params.sector_id_list.join(','));
      }
      if (params.district_id_list && params.district_id_list.length > 0) {
        httpParams = httpParams.set('district_id_list', params.district_id_list.join(','));
      }
      if (params.limit !== undefined) {
        httpParams = httpParams.set('limit', params.limit.toString());
      }
      if (params.offset !== undefined) {
        httpParams = httpParams.set('offset', params.offset.toString());
      }
    }

    return this.http.get('/schedules/employee_active_days/', { params: httpParams });
  }

  updateEmployeeActiveDay(id: number, isActive: boolean): Observable<any> {
    return this.http.patch(`/schedules/employee_active_days/${id}/`, { is_active: isActive });
  }
}
